import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 203	以上反复
 */

export default class EventLoopAboveStart extends EventBase {
  /**
   * 以上反复的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }
  /**
   * 剧情ID
   */
  Code = EventID.LoopAboveStart
  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
